export default __webpack_public_path__ + "static/media/0003.71c9b299.svg";